module.exports = __webpack_public_path__ + "static/admin-1722346021160/img/asset_logo.82b9c7a5.png";